export default __webpack_public_path__ + "static/media/m2.a92a175a.png";